import { Config } from '../actions/configActions';    
const INITIAL_STATE = { 
                        menu : {}
                      };


    export default function(state = INITIAL_STATE,action){

            return {
                        menu : {
                                raiz: Config().raiz,
                                home: '/home',
                                nave:{equipe:'nave/equipe',individual:'nave/individual'},
                                login: `${Config().raiz}/login`,
                                nave: {
                                        home:'/home/nave'
                                      },
                                desafios: {
                                        home               : '/home/desafios',
                                        desafio_turma      : '/home/desafio_turma',
                                        desempenho         : '/home/desempenho_aluno',
                                        desafioquiz        : '/home/desafio-quiz',
                                        desafioquizaction  : '/home/desafio-quiz-action',
                                        desafiosenha       : '/home/desafio-senha',
                                        desafiosenhaaction : '/home/desafio-senha-action',
                                        desafiobomba       : '/home/desafio_bomba',
                                        desafiobombaaction : '/home/desafio-bomba-action',
                                        novo               : '/home/desafio-novo',
                                        editar             : '/home/desafios-editar',
                                        duplicar           : '/home/desafios-duplicar',
                                        jogos              : '/home/desafios-jogo',
                                        jogo :{
                                               jogo1 : 'Código de Acesso',
                                               jogo2 : 'Desarmando Bomba',
                                               jogo3 : 'Roda do Destino',
                                               tipo1 : 'palavrachave',
                                               tipo2 : 'forca',
                                               tipo3 : 'quiz',
                                              },
                                        nomeModulo   : 'Desafios'
                                },
                                equipe : {
                                        home             : '/home/equipe',
                                        aluno            : '/home/equipe_aluno/:id',
                                        alunoid          : '/home/equipe_aluno',
                                        professor :{
                                            home             : '/home/equipe',
                                            equipe_turma     : '/home/equipe_turma',
                                            turma_aluno      : '/home/turma_aluno',
                                            timeline_equipe  : '/home/timeline_equipe',
                                        },
                                        nomeModulo   : 'Equipe'
                                },
                                turma : {                                 
                                  professor :{                                   
                                      timeline_turma : '/home/timeline_turma',
                                  }
                                },
                                missao: {
                                        home        : '/home/missao',
                                        concluir    : '/home/missao_concluir',
                                        recompensa  : '/home/missao_recompensa',
                                        novo        : '/home/missao_cadastro',
                                        editar      : '/home/missao_editar',
                                        resposta    : '/home/missao_respostas',
                                        aluno       : '/home/equipe_aluno/:id',
                                        alunoid     : '/home/equipe_aluno',
                                        missao_lista      : '/home/missao_lista',
                                        nomeModulo  : 'Missão'
                                },
                                batalha: {
                                  aluno:{
                                    home : '/home/batalha',
                                    jogo : '/home/batalha-jogo'
                                  },
                                  professor:{
                                    home : '/home/batalha'
                                  },
                                  limitQuestao : 3,
                                  nomeModulo   : 'Batalha'
                                },
                                jogos : {
                                  home:'/home/Jogos'
                                },
                                jogo   : '/home/jogo',
                                perfil : {
                                  home:'/home/perfil'
                                },
                                questao : '/home/questao',
                                condecoracoes:{
                                  home:'/home/condecoracoes'
                                },
                                pontuacao:'/home/pontuacao',
                                regras:{
                                  home:'/home/regras'
                                },
                                recursos:{
                                  home       :'/home/recursos',
                                  nomeModulo : 'Recursos'
                                },
                                relatorio:{
                                  home         : '/home/relatorio',
                                  rankingAluno : '/home/rankingAluno',
                                  rankingTurma : '/home/rankingTurma',
                                  nomeModulo   : 'Relatório'
                                },
                                comunicacao:{
                                  tripulacao : '/home/tripulacao',
                                  equipes    : '/home/equipes',
                                  equipe     : '/home/equipe',
                                },
                                talentos:{home:'/home/talentos'},
                               
                        },
                        config : {
                                userAluno  : 1,
                                userProfessor : 2,
                        }
                   }
}







// WEBPACK FOOTER //
// ./src/reducers/reducer_config.js